<ng-template #content let-modal class="background">
  <div class="content">
    <div class="container">
      <div class="row row-mobile">
        <div class="col">
          <button class="share-button">
            <a href="http://www.facebook.com/share.php?u={{url}}" target="_blank" (click)="modal.close()">
              <img [src]="constants.FACEBOOK_SHARE_IMG" class="share-icon" alt="facebook">
              {{constants.FACEBOOK_TXT}}
            </a>
          </button>
        </div>
        <div class="col">
          <button class="share-button">
            <a href="https://wa.me/?text={{url}}" target="_blank" (click)="modal.close()">
              <img [src]="constants.WHATSAPP_SHARE_IMG" class="share-icon" alt="instagram">
              {{constants.WHATSAPP_SHARE_TXT}}
            </a>
          </button>
        </div>
        <div class="col">
          <button class="share-button">
            <a href="https://twitter.com/intent/tweet?text=Watch {{author}}'s window from {{location}} on WindowSwap &hashtags=windowswap &url={{url}}" target="_blank" (click)="modal.close()">
              <img [src]="constants.TWITTER_SHARE_IMG" class="share-icon" alt="twitter">
              {{constants.TWITTER_TXT}}
            </a>
          </button>
        </div>
        <div class="col">
          <button class="share-button" (click)="copyText($event)">
            <img [src]="constants.COPY_LINK_IMG" class="share-icon" alt="copy link">
            <span *ngIf="!textCopied">{{constants.COPY_LINK_TXT}}</span>
            <span *ngIf="textCopied">{{constants.LINK_COPIED}}</span>
          </button>
        </div>
      </div>
    </div>
  </div>

</ng-template>
<button class="shareWrapper" (click)="openVerticallyCentered(content)">
  <img class="control-icon-1" [src]="constants.SHARE_BTN_MOBILE"/> 
  <img class="control-icon" [src]="constants.SHARE_BTN_IMG" />
</button>